import React, { useState, useEffect } from 'react';
import './FadeImageSlider.css';

import img1 from '../../assets/slider-images/img1.jpg'
import img2 from '../../assets/slider-images/img2.jpg'
import img3 from '../../assets/slider-images/img3.jpg'
import img4 from '../../assets/slider-images/img4.jpg'
import { useNavigate } from 'react-router-dom';
const FadedImageSlider = () => {
    const images = [img1,img2,img3,img4]; // Add more images if needed
    const Navigate =useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // Change image every 5 seconds
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div className="slider-container">
            {/* Slider Image */}
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`slider-image ${index === currentIndex ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${image})` }}
                ></div>
            ))}

            {/* Overlay content */}
            <div className="slider-content">
                <div className='homepage-silder-title'>GENERAL PRACTITIONER’S <br /> ASSOCIATION OF ICHALKARANJI</div>
                <p>The General Practitioners Association of Ichalkaranji was established in 2018 and includes doctors from Allopathy, Ayurveda, Unani and  Homeopathy . It focuses on updating medical knowledge through case discussions, CME programs, and hands-on workshops with experts across specialties.</p>
                <div className="buttons">
                    <button className="join-btn" onClick={()=>Navigate('/about')}>Know More</button>
                </div>
            </div>
        </div >
    );
};

export default FadedImageSlider;
